import React from 'react';
import { Link as MUILink } from '@mui/material';
import { LinkProps } from '@mui/material/Link';
import { Link, useLocation } from 'react-router-dom';
import { urls } from 'shared/constants/routing.constants';

// we need custom variant because MUI Link reloads page on click
const CustomLink = ({ href, ...props }: LinkProps) => {
  const location = useLocation();
  const isActiveDebate = location.pathname.startsWith(urls.myPages.video);

  return (
    <MUILink component={Link} to={href} target={isActiveDebate ? '_blank' : '_self'} {...props} />
  );
};

export default CustomLink;
